import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { useNotification } from "~hooks/useNotification";
import type { User, UserResponse } from "~types/user";
import type { AddUserForm } from "../types";

const useAddUser = (onSuccess: (userData: User) => void) => {
  const { sport, organizationId } = useParams();
  const request = useApi();
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const notification = useNotification();

  return useMutation<UserResponse, Error, AddUserForm>({
    mutationFn: async (userData: AddUserForm) => {
      return await request(`${sport}/o/${organizationId}/users`, {
        method: "POST",
        body: userData,
      });
    },
    onSuccess: async (response: { data: User[] }) => {
      if (response?.data?.length > 0) {
        await queryClient.invalidateQueries({
          queryKey: ["permission-users", sport, organizationId],
        });

        notification.success({
          message: formatMessage({
            id: "permissions.user.actions.add.success",
          }),
          placement: "bottomRight",
        });

        onSuccess(response.data[0]);
      }
    },
  });
};

export default useAddUser;
